var AssetDirectory = {
	"load": [
		"assets/bgm/bgm.ogg",
		"assets/game/fx_firsttimeplay_glow.png",
		"assets/game/fx_sparkle_ske.json",
		"assets/game/fx_sparkle_tex.json",
		"assets/game/fx_sparkle_tex.png",
		"assets/game/goat_anim_ske.json",
		"assets/game/goat_anim_tex.json",
		"assets/game/goat_anim_tex.png",
		"assets/game/gs_prop1.png",
		"assets/game/gs_prop2.png",
		"assets/game/gs_prop3.png",
		"assets/game/gs_prop4.png",
		"assets/game/gs_prop5.png",
		"assets/game/gs_prop6.png",
		"assets/game/gs_prop7.png",
		"assets/game/gs_prop8.png",
		"assets/game/img_fence_back.png",
		"assets/game/img_fence_front.png",
		"assets/game/img_game_bg.png",
		"assets/game/img_ground_overlay.png",
		"assets/game/img_sign_1.png",
		"assets/game/img_sign_2.png",
		"assets/game/lion_anim_ske.json",
		"assets/game/lion_anim_tex.json",
		"assets/game/lion_anim_tex.png",
		"assets/game/sheep_anim_ske.json",
		"assets/game/sheep_anim_tex.json",
		"assets/game/sheep_anim_tex.png",
		"assets/sfx/animal_pickup.ogg",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/goat.ogg",
		"assets/sfx/lamb.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/title/img_title_bg.png",
		"assets/title/img_title_gizmo.png",
		"assets/title/img_title_logo.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_replay.png",
		"assets/ui/btn_replay2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starBG.png",
		"assets/ui/htp_separate1.png",
		"assets/ui/htp_separate2.png",
		"assets/ui/htp_separate3.png",
		"assets/ui/htp_separate4.png",
		"assets/ui/htp_separate5.png",
		"assets/ui/htp_separate6.png",
		"assets/ui/htp_separate7.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preloader_strings/GizmoLoading_ske.json",
		"assets/preloader_strings/GizmoLoading_tex.json",
		"assets/preloader_strings/strings.json",
		"assets/preloader_ui/gfx_bg.png",
		"assets/preloader_ui/gfx_loading.png",
		"assets/preloader_ui/gfx_loading_bar_con.png",
		"assets/preloader_ui/GizmoLoading_tex.png",
		"assets/preload_fonts/exo-bold.ttf",
		"assets/preload_fonts/exo-medium.ttf",
		"assets/preload_fonts/proximanova-black.ttf"
	],
	"preloadstring": [
		"assets/strings/config.json"
	]
};